jQuery(document).ready(function($) {

	// filters
	// http://isotope.metafizzy.co/
	(function(isotope) {
		// define layout mode that doesn't position items
		Isotope.Item.prototype._create = function() {
			this.id = this.layout.itemGUID++;
			this._transn = {
				ingProperties: {},
				clean: {},
				onEnd: {}
			};
			this.sortData = {};
		};
		Isotope.Item.prototype.layoutPosition = function() {
			this.emitEvent('layout', [this]);
		};
		Isotope.prototype.arrange = function(opts) {
			this.option(opts);
			this._getIsInstant();
			this.filteredItems = this._filter(this.items);
			this._isLayoutInited = true;
		};
		Isotope.LayoutMode.create('none');

		// check "all" if nothing else is selected
		var $checkAll = $('.js-form-checkbox-all');
		var $checkAllParent = $checkAll.parents('.checkbox');
		var $checkCategories = $('.js-checkbox-categories .js-form-checkbox:not(.js-form-checkbox-all)')

		$checkAll.iCheck('check');
		$checkAllParent.addClass('untoggleable');
		$checkCategories.on('ifChanged', function() {
			if ($checkCategories.filter(':checked').length === 0) {
				$checkAll.iCheck('check');
				$checkAllParent.addClass('untoggleable');
			} else {
				$checkAll.iCheck('uncheck');
				$checkAllParent.removeClass('untoggleable');
			}
		});

		// filter variables
		var categoryFilters = [];
		var categoryFilter;
		var selectedCategoryNames = [];
		var selectedCategoryNamesString;

		// initialise isotope
		var $diningList = $('.js-dining-list').isotope({
			itemSelector: '.item',
			layoutMode: 'none',
			transitionDuration: 0,
			filter: function() {
				var $this = $(this);
				if (!categoryFilters.length) {
					return 'all';
				}
				for (var i = 0; i < categoryFilters.length; i++) {
					if ($this.is('[data-category*=' + categoryFilters[i] + ']')) {
						return $this;
					}
				}
			}
		});

		// apply filter
		$('.js-checkbox-categories').on('ifChecked', '.js-form-checkbox', function(event) {
			if ($.inArray($(this).val(), categoryFilters) <= -1) {
				categoryFilters.push($(this).val());
				selectedCategoryNames.push($(this).parent().siblings('.js-checkbox-label').text());
				$diningList.isotope();
			}
			if ($(this).val() === 'all') {
				$('.js-checkbox-categories .js-form-checkbox:not([value="all"])').iCheck('uncheck');
			} else {
				$('.js-checkbox-categories .js-form-checkbox[value="all"]').iCheck('uncheck');
				if ($.inArray('all', categoryFilters) >= 0) {
					for (var i = 0; i < categoryFilters.length; i++) {
						if (categoryFilters[i] === 'all') {
							categoryFilters.splice(i, 1);
							$diningList.isotope();
						}
					}
				}
			}
		});

		// remove filter
		$('.js-checkbox-categories').on('ifUnchecked', '.js-form-checkbox', function(event) {
			if ($(this).val() !== 'all') {
				for (var i = 0; i < categoryFilters.length; i++) {
					if (categoryFilters[i] === $(this).val()) {
						categoryFilters.splice(i, 1);
					}
				}
			}
			for (var n = 0; n < selectedCategoryNames.length; n++) {
				if (selectedCategoryNames[n] === $(this).parent().siblings('.js-checkbox-label').text()) {
					selectedCategoryNames.splice(n, 1);
				}
			}
			$diningList.isotope();
		});

		// update results counts and categories
		// show no results message if no results
		var updateResultsMessage = function() {
			if ( $diningList.length ){


				var $visibleItems = $diningList.find('.item:visible');
				var visibleItemsLength = $visibleItems.length;

				$('.js-results-count').text(visibleItemsLength);

				selectedCategoryNamesString = selectedCategoryNames.length ? selectedCategoryNames.join(', ') : 'All Dining';
				$('.js-selected-categories').each(function() {
					$(this).text(selectedCategoryNamesString);
				})

				if (visibleItemsLength === 0) {
					$('.js-filter-message-no-results').fadeIn();
				} else {
					$('.js-filter-message-no-results').hide();
				}
			}
		};

		updateResultsMessage();

		$diningList.on('arrangeComplete', function(event, filteredItems) {
			updateResultsMessage();
		});

	}());


});
